import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import React, {Component, useState, useEffect} from "react"
import { Rating } from '@material-ui/core';
 

import _get from "lodash/get"

import '../../css/style.css'

import Star from "../components/star"
import Marquee from "react-fast-marquee";


const Review = () => {


    const data = useStaticQuery(graphql`
    query {
        allGooglePlacesPlace {
            edges {
                node {
                    rating
                    user_ratings_total
                }
            }
        }
        allGooglePlacesReview {
            edges {
                node {
                    author_name
                    text
                    rating
                    author_url
                }
            }
        }
    }`)
    const [reviews, setReviews] = useState(0);
    
    useEffect(() => {      
        setReviews(_get(data, 'allGooglePlacesReview.edges'));    
    },[])
      
    console.log({reviews}.reviews);
    if({reviews}.reviews.length !== undefined){
        return (
            <div className="container">
                <div className="review col-12">
                    <div className="review-summary">
                        <div><h1>Customer Review</h1></div>
    
                        
                        <span>
                            <Star score={data.allGooglePlacesPlace.edges[0].node.rating}/>&nbsp;&nbsp;
                            {data.allGooglePlacesPlace.edges[0].node.rating} out of 5</span>
                        <p>{data.allGooglePlacesPlace.edges[0].node.user_ratings_total} customer ratings</p>
    
                        <div className="row">
                            <Marquee pauseOnHover={true} speed={40} gradientWidth={150} gradientColor={[30,31,33]}>
                                {{reviews}.reviews.map(review => (
                                    <div className="review-detail">
                                        <span className="review-author">{review.node.author_name}</span><Star score={review.node.rating}/>
                                        <div className="review-content">
                                            <p>{review.node.text}</p>
                                        </div>
                                    </div>
                                ))}
                            </Marquee>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    else {
        return (
            <div className="container">
                <div className="review col-12">
                    <div className="review-summary">
                        <div><h1>Customer Review</h1></div>
    
                        
                        <span>
                            <Star score={data.allGooglePlacesPlace.edges[0].node.rating}/>&nbsp;&nbsp;
                            {data.allGooglePlacesPlace.edges[0].node.rating} out of 5</span>
                        <p>{data.allGooglePlacesPlace.edges[0].node.user_ratings_total} customer ratings</p>
    
                    </div>
                </div>
            </div>
        )
    }
 
}

export default Review
